import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../../../core/modelos/user';

@Injectable()
export class UsuariosService {

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getUsuarios(): Observable<any> {
        return this.http.get(environment.urlBase + 'users', this.constantes.httpOptions);
    }

    getUsuario(id: number): Observable<any> {
        return this.http.get(environment.urlBase + 'users/' + id, this.constantes.httpOptions);
    }

    updateUsuario(usuario: User): Observable<any> {
        return this.http.put(environment.urlBase + 'users/' + usuario.id, usuario, this.constantes.httpOptions);
    }

    addUsuario(usuario: User): Observable<any> {
        return this.http.post<User>(environment.urlBase + 'users', usuario, this.constantes.httpOptions);
    }

    deleteUsuario (id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'users/' + id, this.constantes.httpOptions);
    }
    getRoles(): Observable<any> {
        return this.http.get(environment.urlBase + 'roles', this.constantes.httpOptions);
    }

    cambiarPassword(newpassword: string): Observable<any> {
        return this.http.post(environment.urlBase + 'changepassword', {newpassword}, this.constantes.httpOptions);
    }

    forgotPassword(email: string): Observable<any> {
        return this.http.post(environment.urlBase + 'resetpassword', {email});
    }    

}



// WEBPACK FOOTER //
// ./src/app/main/content/usuarios/usuarios.service.ts